var _circle, _circle2, _circle3, _circle4, _path, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_89367",
    "data-name": "Group 89367",
    xmlns: "http://www.w3.org/2000/svg",
    width: 192.113,
    height: 192.113,
    viewBox: "0 0 192.113 192.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 7.233,
    cy: 7.233,
    r: 7.233,
    transform: "translate(88.821 24.472)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 7.233,
    cy: 7.233,
    r: 7.233,
    transform: "translate(88.821 154.908)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 7.233,
    cy: 7.233,
    r: 7.233,
    transform: "translate(23.602 88.823)",
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 7.233,
    cy: 7.233,
    r: 7.233,
    transform: "translate(154.037 88.823)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M49.108,81.812A7.218,7.218,0,0,1,46.6,67.82V22.5h5.013V67.818a7.246,7.246,0,0,1,2.03,1.167L73.064,56.946l2.646,4.261-19.5,12.085a7.372,7.372,0,0,1,.13,1.287A7.233,7.233,0,0,1,49.108,81.812Z",
    transform: "translate(46.948 21.478)",
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 7.233,
    cy: 7.233,
    r: 7.233,
    transform: "translate(58.143 32.604)",
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 7.233,
    cy: 7.233,
    r: 7.233,
    transform: "translate(119.031 145.043)",
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 7.233,
    cy: 7.233,
    r: 7.233,
    transform: "translate(35.177 121.566)",
    fill: "#fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 7.233,
    cy: 7.233,
    r: 7.233,
    transform: "translate(142.036 56.083)",
    fill: "#fff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 7.233,
    cy: 7.233,
    r: 7.233,
    transform: "translate(119.031 32.606)",
    fill: "#fff"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 7.233,
    cy: 7.233,
    r: 7.233,
    transform: "translate(58.145 145.043)",
    fill: "#fff"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 7.233,
    cy: 7.233,
    r: 7.233,
    transform: "translate(35.177 56.083)",
    fill: "#fff"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 7.233,
    cy: 7.233,
    r: 7.233,
    transform: "translate(142.036 121.566)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M3.5,99.556A96.056,96.056,0,1,0,31.634,31.634,95.786,95.786,0,0,0,3.5,99.556Zm16.2,0a79.852,79.852,0,1,1,23.389,56.467A79.566,79.566,0,0,1,19.7,99.556Z",
    transform: "translate(-3.5 -3.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.abee35991acfeeed90a3612b2ec5e5b9.svg";
export { ForwardRef as ReactComponent };